/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dialogue': {
    width: 24,
    height: 21,
    viewBox: '0 0 24 21',
    data: '<path pid="0" data-name="矩形 9" d="M2.667 0h18.666A2.646 2.646 0 0 1 24 2.625v11.813a2.646 2.646 0 0 1-2.667 2.625H10.682L4 21l.016-3.938H2.667A2.646 2.646 0 0 1 0 14.438V2.625A2.646 2.646 0 0 1 2.667 0z" _fill="#d8d8d8" fill-rule="evenodd"/>'
  }
})
